import React, { useEffect, useState } from "react";
import { Loader2, Mail, Phone, MessageSquare } from "lucide-react";
import api from "@/lib/api";
import { initials } from "@/lib/utils-app";

export default function MyHandlaggare() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/me/handlaggare")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up">
      <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">Kontakt</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-900" style={{ fontFamily: "Outfit" }}>
        Din handläggare
      </h1>
      <p className="mt-2 text-zinc-500">Personerna på kommunen som hanterar dina bygglovsärenden.</p>

      {loading ? (
        <div className="flex justify-center py-20 text-zinc-500"><Loader2 className="w-5 h-5 animate-spin" /></div>
      ) : items.length === 0 ? (
        <div className="mt-8 bg-white border border-zinc-200 rounded-sm py-16 text-center text-sm text-zinc-500">
          Ingen handläggare tilldelad ännu.
        </div>
      ) : (
        <div className="mt-8 space-y-3">
          {items.map((h, i) => (
            <div key={h.user_id} data-testid={`handlaggare-${h.user_id}`}
              className="bg-white border border-zinc-200 rounded-sm p-5">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-full bg-blue-700 text-white flex items-center justify-center text-base font-semibold flex-shrink-0">
                  {initials(h.name)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-lg font-medium text-zinc-900">{h.name}</h3>
                    {i === 0 && h.activity_count > 0 && (
                      <span className="text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-sm">
                        Aktiv på dina ärenden
                      </span>
                    )}
                  </div>
                  <div className="text-sm text-zinc-500">Bygglovshandläggare · Byggnadsnämnden</div>
                  <div className="mt-3 flex flex-col sm:flex-row gap-2 sm:gap-4">
                    {h.email && (
                      <a href={`mailto:${h.email}`} data-testid={`mailto-${h.user_id}`}
                        className="inline-flex items-center gap-2 text-sm text-blue-700 hover:underline">
                        <Mail className="w-3.5 h-3.5" /> {h.email}
                      </a>
                    )}
                    {h.phone && (
                      <a href={`tel:${h.phone}`} className="inline-flex items-center gap-2 text-sm text-blue-700 hover:underline">
                        <Phone className="w-3.5 h-3.5" /> {h.phone}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-sm text-sm text-blue-900 flex gap-3">
            <MessageSquare className="w-4 h-4 stroke-[1.5] flex-shrink-0 mt-0.5" />
            <div>
              <div className="font-semibold">Tips:</div>
              För snabbast svar – skicka ditt meddelande direkt i ärendet. Då kopplas frågan automatiskt till rätt ärende och hamnar inte i e-postkön.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
